<template>
    <div class="nursing-care">
        <div class="chart-card graph-card">
            <p class="chart-card-tit">护理知识图谱</p>
            <knowledge-graph :graph-data="chartData.nursingKnowledgeGraph" title="护理知识图谱" height="420px" />
        </div>
        <div v-if="tagRows.length" class="chart-card tag-card">
            <div v-for="row in tagRows" :key="row.field" class="tag-row">
                <span class="row-label">{{ row.title }}</span>
                <div class="tag-list">
                    <span v-for="(tag, index) in row.tags" :key="index" class="tag-item">{{ tag }}</span>
                </div>
            </div>
        </div>
        <div v-if="charts.length" class="chart-grid">
            <div v-for="item in charts" :key="item.field" class="chart-card">
                <p class="chart-card-tit">{{ item.title }}</p>
                <disease-chart :option="item.option" height="300px" />
            </div>
        </div>
    </div>
</template>

<script>
import DiseaseChart from './disease_chart.vue';
import KnowledgeGraph from './knowledge_graph.vue';
import { SCIENCE_CHART_TYPES, SCIENCE_TAG_TYPES } from '../scienceData';


function buildPieOption(list) {
    return {
        tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)',
        },
        legend: {
            type: 'scroll',
            tooltip: { show: true },
            bottom: 0,
            textStyle: { color: '#5A6779', fontSize: 12 },
        },
        series: [
            {
                type: 'pie',
                // 实心饼图：不设 radius 数组，使用默认色值
                radius: '58%',
                center: ['50%', '46%'],
                data: list || [],
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                },
                label: {
                    formatter: '{b}\n{d}%',
                    fontSize: 12,
                    color: '#333',
                },
                labelLine: {
                    length: 10,
                    length2: 8,
                },
                emphasis: {
                    itemStyle: {
                        shadowBlur: 8,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0,0,0,0.15)',
                    },
                },
            },
        ],
    };
}

export default {
    name: 'NursingCare',
    components: {
        DiseaseChart,
        KnowledgeGraph,
    },
    props: { chartData: { type: Object, default: () => ({}) } },
    computed: {
        tagRows() {
            return SCIENCE_TAG_TYPES.map((item) => ({ ...item, tags: this.chartData[item.field] || [] }))
                .filter((item) => item.tags.length);
        },
        charts() {
            return SCIENCE_CHART_TYPES.filter(({ field }) => (this.chartData[field] || []).length)
                .map((item) => ({ ...item, option: buildPieOption(this.chartData[item.field]) }));
        },
    },
};
</script>

<style lang="less" scoped>
.nursing-care {
    .graph-card, .tag-card { margin-bottom: 16px; }
    .chart-grid {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 16px;
    }
    .tag-row { display: flex; gap: 16px; margin-bottom: 12px; }
    .tag-row:last-child { margin-bottom: 0; }
    .row-label { flex: 0 0 100px; color: #0C55AA; line-height: 28px; }
    .tag-list { display: flex; flex-wrap: wrap; gap: 8px; min-width: 0; }
    .tag-item { padding: 3px 10px; color: #2563EB; background: #EFF6FF; border: 1px solid #93C5FD; border-radius: 4px; overflow-wrap: anywhere; }

    .chart-card {
        min-width: 0;
        background: #fff;
        border: 1px solid #E8EEF8;
        border-radius: 10px;
        padding: 12px 14px 16px;
        box-sizing: border-box;

        &.w-1-2 {
            flex: 1 1 0;
        }
    }

    .chart-card-tit {
        margin: 0 0 8px;
        font-size: 14px;
        font-weight: bold;
        color: #0C55AA;
        line-height: 20px;
    }
}
</style>
